import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash-es';
import { withRouter } from 'react-router-dom';
import { routesForLanguage } from '../routes/routes';
import DataContext from './DataContext/DataContext';

const ContainerStyle = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  box-shadow:1px 1px 3px;
  padding: 20px;
  margin-top: 20px;
`;

function getErrorMessage(error = {}) {
  if (error.response) {
    return get(error, 'response.data.message');
  }
  if (error.message) {
    return error.message;
  }
  return '';
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    const { history } = this.props;
    this.historyUnlisten = history.listen(() => {
      this.setState({ hasError: false, error: null });
    });
    if(window.location.href.includes("error")){
      this.setState({ hasError: true, error: "Page not found" });
    }
  }

  componentWillUnmount() {
    if (this.historyUnlisten) {
      this.historyUnlisten();
    }
  }
   goToStartPage = (e,org, lang) => {
    e.preventDefault(); // Prevents default anchor behavior

    // Remove items from localStorage
    localStorage.removeItem("selectedMarketLang"); 
    localStorage.removeItem("salesArea"); 
    localStorage.removeItem("store"); 
    localStorage.removeItem("interactionData");
    localStorage.removeItem("uniqueID");

    // Redirect to the start page
    window.location.href = routesForLanguage(org, lang).startPageRoute();
  };
  renderError() {
    const { location } = this.props;
    const { error } = this.state;
    const errorMessage = getErrorMessage(error);
    return (
      <DataContext.Consumer>
        {({ org, lang }) => (
          <ContainerStyle>
            <h1>Oops! An error occurred...</h1>
            <p>{errorMessage}</p>
            <p>{location.pathname}</p>
            {/* <a href={routesForLanguage(org, lang).menuRoute()}>Go to menu</a> */}
            <a style={{cursor:"pointer", color:"#00b0ff", fontWeight:"bold"}}onClick={(e)=>this.goToStartPage(e,org, lang)}>Go to start page</a>
          </ContainerStyle>
        )}
      </DataContext.Consumer>
    );
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return this.renderError();
    }

    return children;
  }
}

export default withRouter(ErrorBoundary);
